import { LeadResult, LeadResultType } from "../../../../dtos/LeadResult";

/** A lead result for medical non-candidacy. */
class MedicalNonCanLeadResult extends LeadResult {
  /**
   * @param patientId - The ID of the patient for whom the lead result is being created.
   * @param opportunityId - The ID of the opportunity associated with the lead result.
   * @param disqualifyingReasonId - The ID of the disqualifying reason for medical non-candidacy.
   */
  constructor(patientId: string, opportunityId: string, disqualifyingReasonId: string) {
    super(patientId, opportunityId, LeadResultType.ObxNonCandidateMedical, undefined);
    this.disqualifyingReasons = { ...this.disqualifyingReasons, [disqualifyingReasonId]: true };
  }
}

export default MedicalNonCanLeadResult;
